export default __webpack_public_path__ + "static/media/polo-on.7f490283.svg";